const isDev = (): boolean => {
  return !!["http://localhost:3000", "https://dev.app.comicshelper.com/"].find(
    (a) => a.includes(window.origin)
  );
};

export default isDev;
